module.exports = __webpack_public_path__ + "img/adamas.189b79f2.png";